import datepicker from 'js-datepicker';
import 'js-datepicker/dist/datepicker.min.css'

const customDays   = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
const customMonths = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

const init = (instance) => {
    instance.$btn       = document.querySelector('.search-ext__show-more');
    instance.$dateStart = document.querySelector('.search-ext__date_start');
    instance.$dateEnd   = document.querySelector('.search-ext__date_end');
    instance.$text      = document.querySelector('.search-ext__text');

    instance.$inputStart = document.querySelector('.search-ext__date_start input');
    instance.$inputEnd   = document.querySelector('.search-ext__date_end input');

    instance.$period      = document.querySelector('.search-ext__date-select');
    instance.$periodText  = document.querySelector('.search-ext__date-select p');
    instance.$periodValue = document.querySelector('input[name="range"]');

    instance.startDate = instance.$inputStart.value;
    instance.endDate   = instance.$inputEnd.value;

    instance.$calendarStart = datepicker(instance.$dateStart, {
        customDays:   customDays,
        customMonths: customMonths,
        startDay:     1,
        onSelect:     (calendar, date) => {
            if (date != 'undefined') {
                instance.$inputStart.value = date.toLocaleDateString();
            }
        }
    });
    instance.$calendarEnd   = datepicker(instance.$dateEnd, {
        customDays:   customDays,
        customMonths: customMonths,
        startDay:     1,
        onSelect:     (calendar, date) => {
            if (date != 'undefined') {
                instance.$inputEnd.value = date.toLocaleDateString();
            }
        }
    });

    instance.$btn.addEventListener('click', (event) => {
        $('.search-ext__params').show();
        instance.$btn.style.display = 'none';
    });

    instance.$inputEnd.addEventListener('click', (event) => {
        event.stopPropagation();
    });
    instance.$inputStart.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    instance.$period.addEventListener('click', (event) => {
        $('.search-ext__date-select__list').slideToggle();
    });

    $('.search-ext__date-select__list li').on('click', (event) => {
        let $option = event.target;
        let range   = $option.getAttribute('data-range');
        let today   = new Date();

        instance.$periodText.innerText = $option.innerText;
        instance.$periodValue.value    = range;

        if (range === 'custom') {
            instance.showCalendar();
            instance.endDate = instance.startDate = today;
        }
        if (range === 'twoweeks') {
            instance.hideCalendar();
            instance.endDate   = today;
            instance.startDate = new Date(today - 12096e5);
        }
        if (range === 'month') {
            instance.hideCalendar();


            instance.endDate   = today;
            instance.startDate = new Date(
                today.getFullYear(),
                today.getMonth() === 0
                    ? 11
                    : today.getMonth() - 1,
                today.getDate()
            );
        }

        instance.setSelectedDate();

    })


}

export default class SearchForm {
    constructor($selector) {
        this.$dateStart = null
        this.$dateEnd   = null;
        this.$text      = null;

        this.$inputStart = null;
        this.$inputEnd   = null;

        this.endDate        = null;
        this.startDate      = null;
        this.$calendarEnd   = null;
        this.$calendarStart = null;

        return $selector ? init(this) : {};
    }

    showCalendar() {
        this.$dateStart.style.display = 'inline-block';
        this.$dateEnd.style.display   = 'inline-block';
        this.$text.style.display      = 'inline-block';
    }

    hideCalendar() {
        this.$dateStart.style.display = 'none';
        this.$dateEnd.style.display   = 'none';
        this.$text.style.display      = 'none';
    }

    setSelectedDate() {
        let endDate  = this.endDate.getDate();
        let endMonth = this.endDate.getMonth() + 1 < 10
            ? '0' + (this.endDate.getMonth() + 1)
            : this.endDate.getMonth() + 1;
        let endYear  = this.endDate.getFullYear();
        let endValue = `${endDate}.${endMonth}.${endYear}`

        let startDate  = this.startDate.getDate();
        let startMonth = this.startDate.getMonth() + 1 < 10
            ? '0' + (this.startDate.getMonth() + 1)
            : this.startDate.getMonth() + 1;
        let startYear  = this.startDate.getFullYear();
        let startValue = `${startDate}.${startMonth}.${startYear}`;

        this.$calendarEnd.setDate(this.endDate);
        this.$calendarStart.setDate(this.startDate);

        this.$inputEnd.value   = endValue;
        this.$inputStart.value = startValue;

    }
}
